import React from "react";
import {CurrencyFormatter as OldCurrencyFormatter} from "./formatters";
import TextInput from "../components/form/TextInput";
import {set} from "./dotutils";

export const CurrencyFormatter = (props: any) => OldCurrencyFormatter(props.value);

export const NumberEditable = (props: any) => <TextInput
    label={false}
    autoFocus={true}
    name={props.field}
    type="number"
    value={props.value}
    saveChanges={(field, value) => {
        let item = {...props.data};
        set(item, field, value);
        let items = [item];
        props.editItems(items);
    }}
/>